import ArchiveGallery from "./ArchiveGallery";

function GalleryWall() {
  return (
    <ArchiveGallery
      category="gallerywall"
      showCollectionFilter={false}
      emptyTitle="No gallery wall artwork found in this section."
    />
  );
}

export default GalleryWall;
